import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Avatar from '@deprecated-ui/common/Avatar';
import color from '@deprecated-ui/_style/color';
import { AVATAR_URL } from 'constants/api';
import Link from 'next/link';
import { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleErrorAvatar } from 'utils/general';

import { effects as watchlistEffects } from 'lib/entities/watchlist';
import Image from 'global/Image';
import { LabelVerifiedAccount } from 'global/Labels';
import {
  PAGE_SOURCE,
  PAGE_SOURCE_INDEX,
  mainProfileEvents,
} from 'features/user/analytics/ProfileAnalytics';
import If from 'global/Common/If';

interface UserItemProps {
  pageSource: PAGE_SOURCE;
  pageSourceIndex: keyof typeof PAGE_SOURCE_INDEX;
  user: {
    about: string;
    alert?: any;
    avatar: string;
    email: string;
    is_followed: boolean;
    is_verified: boolean;
    fullname: string;
    id: string;
    username: string;
  };
  activeUserId: number;
  onSuccessFollowUnfollow?: () => void;
}

function UserItem({
  pageSource,
  pageSourceIndex,
  user,
  activeUserId,
  onSuccessFollowUnfollow,
}: UserItemProps) {
  const {
    avatar,
    username,
    fullname,
    id,
    is_followed: followed,
    is_verified,
  } = user;

  const dispatch = useDispatch();
  const [isFollowed, setFollowed] = useState<boolean>(Boolean(followed));
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFollowUser = async () => {
    const type = !isFollowed ? 'FOLLOW' : 'UNFOLLOW';
    const data = {
      userid: id,
      type,
    };

    setIsLoading(true);

    const toggleFollow = await dispatch(watchlistEffects.followUser(data));

    // @ts-ignore
    const { error } = toggleFollow.payload;

    if (toggleFollow) {
      setIsLoading(false);

      if (!error) {
        setFollowed(!isFollowed);
        onSuccessFollowUnfollow?.();
      }
    }
  };

  const buttonType = isFollowed ? 'default' : 'outline-primary';
  const followingText = isFollowed ? 'Following' : 'Follow';
  const avatarUrl = avatar?.startsWith('http')
    ? avatar
    : `${AVATAR_URL}/${avatar}`;

  return (
    // @ts-expect-error
    <Flex align="center" justify="space-between" py="10px">
      {/* @ts-expect-error */}
      <Flex align="center" mr="20px">
        {/* @ts-expect-error */}
        <Avatar size="small" mr="16px">
          <Image
            src={avatarUrl}
            onError={(e) => handleErrorAvatar(e, username)}
          />
        </Avatar>
        <div>
          <Flex align="center">
            <Link
              href={`/${username}?source=${String(pageSourceIndex)}`}
              passHref
            >
              <Text
                as="a"
                onClick={() => mainProfileEvents.onViewProfile(pageSource)}
                target="_blank"
                rel="noopener noreferrer"
                size="16px"
                color="#333333 !important"
              >
                {username}
              </Text>
            </Link>
            <Flex align="center">
              <LabelVerifiedAccount deprecatedVerifiedStatus={is_verified} />
            </Flex>
          </Flex>
          <Text size="16px" color={color.highgray}>
            {fullname}
          </Text>
        </div>
      </Flex>

      <If condition={activeUserId !== Number(id)}>
        <Button
          type={buttonType}
          height="32px"
          width="100px"
          onClick={handleFollowUser}
          style={{ flexShrink: '0' }}
          loading={isLoading}
          radius="4px"
        >
          <Text family="bold" color="inherit">
            {followingText}
          </Text>
        </Button>
      </If>
    </Flex>
  );
}

export default memo(UserItem);
